import {
  ON_LOAD_CONFIG,
  CABINET_TYPE_ADVERT,
  CABINET_TYPE_EXCHANGE,
  CABINET_TYPE_WEBMASTER,
  CABINET_TYPE_DSP
} from "../constants/config";

export const initialState = null;

export default function configReducer(state = initialState, action) {
  if (action.type == ON_LOAD_CONFIG) {
    const payload = action.payload;
    const config = {
      ...state,
      ...payload
    };
    config.__proto__ = {
      isAdwile: () => payload.CABINET_TYPE === CABINET_TYPE_ADVERT,
      isDSP: () => payload.CABINET_TYPE === CABINET_TYPE_DSP,
      isExchange: () => payload.CABINET_TYPE === CABINET_TYPE_EXCHANGE,
      isWebmaster: () => payload.CABINET_TYPE === CABINET_TYPE_WEBMASTER,
      teaserImgUrl: (image, size = "") =>
        `${payload.TEASER_IMAGE_HOST}${size}/${image}`
    };

    return config;
  }
  return state;
}
